import api from "services/api";
import { getSecureLocalItem } from "utils/secureSessionStorage";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

// Get roles
export const getRoles = async () => {
  return api.get("/v1/api/get-role-list-with-taken-flag");
};

// Assign role to user
export const assignRoleToUserService = async (roleData) => {
  return api.post("/v1/api/assign-role-to-user", roleData);
};